import {ComponentType}                                                                        from '@angular/cdk/portal';
import {DatePipe, NgClass, NgComponentOutlet}                                                 from '@angular/common';
import {Component, effect, inject}                                                            from '@angular/core';
import {Timestamp}                                                                            from '@angular/fire/firestore';
import {FormsModule, ReactiveFormsModule}                                                     from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef}                                                        from '@angular/material/dialog';
import {CrudRecordIntf, CrudRecordType, GlobalDataTypesDict, VapeRecordLogIntf, VapeTypesDry} from '@djsharkk/logr-types';
import {DateTime}                                                                             from 'luxon';
import {DataFactoryService}                                                                   from '../../../../../logr-services/data/data-factory.service';
import {FirebaseToolsService}                                                                 from '../../../../../logr-services/firebase/firebase-tools.service';
import {UiDialogsService}                                                                     from '../../../../utils/ui-dialogs.service';
import {InputWrapperComponent}                                                                from '../../../forms/input-wrapper/input-wrapper.component';
import {DialogWrapperComponent, DialogWrapperContentIntf}                                     from '../../dialog-wrapper/dialog-wrapper.component';
import {DialogEditBase}                                                                       from '../dialog-edit-base';
import {DialogEditCaffComponent}                                                              from '../dialog-edit-caff/dialog-edit-caff.component';
import {DialogEditFoodComponent}                                                              from '../dialog-edit-food/dialog-edit-food.component';
import {DialogEditMedsComponent}                                                              from '../dialog-edit-meds/dialog-edit-meds.component';
import {DialogEditMindComponent}                                                              from '../dialog-edit-mind/dialog-edit-mind.component';
import {DialogEditMoodComponent}                                                              from '../dialog-edit-mood/dialog-edit-mood.component';
import {DialogEditVapeComponent}                                                              from '../dialog-edit-vape/dialog-edit-vape.component';

export interface DialogEditRecordDataIntf {
	content: DialogWrapperContentIntf
	type: CrudRecordType;
	data: CrudRecordIntf;
}

@Component({
			   selector   : 'app-dialog-edit-record-wrapper',
			   imports: [
				   NgComponentOutlet,
				   DialogWrapperComponent,
				   DatePipe,
				   InputWrapperComponent,
				   ReactiveFormsModule,
				   FormsModule,
				   NgClass
			   ],
			   templateUrl: './dialog-edit-wrapper.component.html',
			   styleUrl   : './dialog-edit-wrapper.component.css'
		   })
export class DialogEditWrapperComponent {
	public dialogRef: MatDialogRef<DialogEditWrapperComponent, boolean> = inject(MatDialogRef);
	public data: DialogEditRecordDataIntf = inject(MAT_DIALOG_DATA)
	private svcDialogSvc = inject(UiDialogsService)
	private svcFirebaseTools = inject(FirebaseToolsService)
	private svcDataFactory = inject(DataFactoryService)

	loading = false;

	rec: CrudRecordIntf;

	dialogEditComps: { [key in CrudRecordType]: ComponentType<DialogEditBase<any>> } = {
		vape: DialogEditVapeComponent,
		meds: DialogEditMedsComponent,
		mood: DialogEditMoodComponent,
		mind: DialogEditMindComponent,
		body: DialogEditMindComponent,
		caff: DialogEditCaffComponent,
		food: DialogEditFoodComponent
	}
	dateInputString: string = '';
	dateInputObject: Date = new Date();

	constructor() {
		this.rec = this.data.data;
		effect(() => {
			this.updateDateFormats();
			this.rec = this.data.data;
		});
	}

	updateDate($event: string): void {
		const dtObj = DateTime.fromJSDate(new Date($event));
		this.data.data.timestamp = Timestamp.fromDate(dtObj.toJSDate());
		this.updateDateFormats();
	}

	updateDateFormats() {
		this.dateInputString = DateTime.fromMillis(this.data.data.timestamp.toMillis())?.toFormat('yyyy-MM-dd\'T\'HH:mm:ss')
		this.dateInputObject = this.data.data.timestamp.toDate();
	}

	onConfirm(): void {

		this.loading = true;
		const dict = GlobalDataTypesDict[this.data.type];

		if (dict.type === 'vape') {
			this.svcDataFactory.svcDataVape.updateRecord(this.data.data as VapeRecordLogIntf).then(() => {
				this.loading = false;
				this.dialogRef.close(false);
			})
		} else {
			this.svcFirebaseTools
				.recUpdate(
					`${this.data.type}_records_log`,
					this.data.data.id as string,
					this.data.data
				).then(() => {
				this.loading = false;
				this.dialogRef.close(true);
			})
		}
	}

	onCancel(): void {
		this.svcDialogSvc
			.dialogConfirm('discard')
			.then(confirmed => {
				if (confirmed) {
					this.data.data = this.rec;
					this.dialogRef.close(false);
				} else {

				}
			})
	}

	protected readonly VapeTypesDry = VapeTypesDry;
}
